import React from "react";
import MapWrapper from "components/map/MapWrapper"
import DimensionService from "services/DimensionsService"
import AuthContext from 'store/AuthContext';
import { useLanguage } from "pages/dimension/LanguageContext";
import NativeInterface from "services/NativeInterface";

const DimensionMap: React.FC<{dimensionId: string}> = (props) => {
    const authCtx = React.useContext(AuthContext)
    const [content, setContent] = React.useState<any>(null);
    const langCtx = useLanguage();

    React.useEffect(() => {
        authCtx.logAnalyticsEvent('WebMapView', {dimension: props.dimensionId})
        DimensionService.getMapContent(authCtx.account.getDimensionEnv(props.dimensionId), props.dimensionId, {})
        .then(data => {
            setContent(data)
        })
        .catch(error => {
            console.log(`No map content for dimension. Status: ${error}`)
        })

        if (NativeInterface.isPWA()) {
            if (props.dimensionId == '3382710084' && !authCtx.account.developer) {
                window.history.pushState(null, '', window.location.href);
                window.history.replaceState(null, '', window.location.href);
            }
        }
    }, [])

    function logAnalyticsEvent(event: string, params: any) {
        authCtx.logAnalyticsEvent(event, {...params, ...{dimension: props.dimensionId}})
    }

    return (
        <div style={{width: "100%", height: "100%"}}>
            <MapWrapper content={{langCtx: langCtx,
                                  dimension: props.dimensionId,
                                  env: authCtx.account.getDimensionEnv(props.dimensionId),
                                  content: content,
                                  logAnalyticsEvent: logAnalyticsEvent
                                }}
                        geolocation={{liveGeolocation: true}}/>
        </div>
    );
};

export default DimensionMap;
